import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Guided, 2 questions: where do the contacts come from? what do you call it?
export function NewLeadSourceDialog({ open, onOpenChange, tid, catalog, onCreated }) {
  const api = useApi();
  const [kind, setKind] = useState(null);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setKind(null); setName(""); } }, [open]);
  const pick = (c) => { setKind(c); setName(c.title); };
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/t/${tid}/lead-sources`, { kind: kind.kind, name }); toast.success("Fonte collegata"); onCreated(data); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto sm:max-w-lg" data-testid="lead-source-dialog">
        <DialogHeader><DialogTitle>{kind ? "2. Come la chiami?" : "1. Da dove arrivano i contatti?"}</DialogTitle>
          <DialogDescription>{kind ? kind.what : "Scegli una fonte: potrai collegarne altre dopo."}</DialogDescription></DialogHeader>
        {!kind ? <div className="grid gap-2 sm:grid-cols-2">{catalog.map((c) => (
          <button key={c.kind} type="button" onClick={() => pick(c)} data-testid={`lead-kind-${c.kind}`}
            className="rounded-lg border border-slate-200 p-3 text-left transition-colors hover:border-sky-400 hover:bg-sky-50">
            <span className="block text-sm font-medium text-slate-800">{c.title}</span>
            <span className={`mt-1 inline-block rounded px-1.5 py-0.5 text-[11px] ${c.connectable ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-800"}`}>{c.connectable ? "Lead veri" : "Simulazione"}</span>
          </button>))}</div>
          : <div className="space-y-3">
            <div className="space-y-1.5"><Label htmlFor="ls-name">Nome della fonte</Label>
              <Input id="ls-name" value={name} maxLength={80} onChange={(e) => setName(e.target.value)} data-testid="lead-source-name" /></div>
            <p className="text-xs text-slate-600"><b>Cosa serve davvero:</b> {kind.needs}</p>
            {!kind.connectable && <p className="rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="lead-source-sim-warning">Simulazione: riceverai un indirizzo webhook di prova e il pulsante «Invia lead di prova». Nessun account {kind.title} viene collegato.</p>}
          </div>}
        <DialogFooter className="gap-2">
          {kind && <Button variant="outline" className="h-10" onClick={() => setKind(null)} data-testid="lead-source-back">Indietro</Button>}
          {kind && <Button className="h-10" disabled={busy || name.trim().length < 2} onClick={save} data-testid="lead-source-save">{busy && <Loader2 size={15} className="mr-1.5 animate-spin" />}Collega</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>);
}
